(function () {
    'use strict';

    angular
        .module('Lavpop-store.directives')
        .directive('customPagination', CustomPagination);

    /** @ngInject */
    function CustomPagination(PATHS) {

        function CustomPaginationController($scope) {
            var vm = this;

            $scope.$watch('vm.currentPage', (newValue, oldValue) => {
                if (newValue)
                    vm.setPagination();
            })

            vm.onClick = pageData => {
                if (pageData.page < 1 || pageData.page > vm.numberOfPages) return;

                const callback = vm.onPageClick({
                    pageData
                });

                if (typeof callback === 'function') {
                    callback(pageData);
                }
            }

            vm.setPagination = () => {
                let pages = [];
                let start = 1;
                let end;

                start = Math.max(start, vm.currentPage - Math.abs(Math.floor(vm.displayedPages / 2)));
                end = start + vm.displayedPages;

                if (end > vm.numberOfPages) {
                    end = vm.numberOfPages + 1;
                    start = Math.max(1, end - vm.displayedPages);
                }

                for (let i = start; i < end; i++)
                    pages.push(i);

                vm.pages = pages;
            }
        }

        function link(scope, attrs, elem, ctrl) {
            ctrl.setPagination();
        }

        return {
            bindToController: true,
            link: link,
            controller: CustomPaginationController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/custom-pagination/custom-pagination.html`,
            scope: {
                onPageClick: '&',
                numberOfPages: '=',
                currentPage: '=',
                displayedPages: '='
            }
        }
    }
}());
